module.exports = __webpack_public_path__ + "img/SPQRvs420.6bc5cb70.png";